var map = {
	"./shiba-head-level1.png": "5077",
	"./shiba-head-level2.png": "6f5c",
	"./shiba-head-level3.png": "1d0f",
	"./shiba-head-level4.png": "b933",
	"./shiba-head-level5.png": "a2d0",
	"./shiba-head-level6.png": "7a37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf49";